import {Component, OnInit} from '@angular/core';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';

@Component({
    selector: 'app-hierachie-class-p',
    templateUrl: './hierachie-class-p.component.html',
    styleUrls: ['./hierachie-class-p.component.css']
})
export class HierachieClassPComponent implements OnInit {
    public data: any[] = [];
    public datatree: any[] = [];
    public firsttable: boolean = true;
    public idcat = '';

    constructor(private catalogueService: CatalogueService) {
    }

    ngOnInit(): void {
        this.loadData();
        this.loadDatatree();

    }

    loadData() {

        this.catalogueService.loadHierachieListP(this.idcat)
            .subscribe(response => {
                this.firsttable = true;

                this.data = response['payload'];


            });

    }

    loadDatatree() {

        this.catalogueService.loadHierachieTreeP(this.idcat)
            .subscribe(response => {

                this.datatree = response['payload'];


            });
    }

    onSearch($event: any) {

        this.idcat = $event;
        this.loadData();
        this.loadDatatree();


    }


}
